import axios from 'axios';

export const fetchAuthUser = async () => {
  const { data } = await axios.get('/auth/user');
  return data;
};

export const fetchHealthCheckInfo = async () => {
  const { data } = await axios.get('/api/healthcheck');
  return data;
};

export * from './client';
export * from './slides';
export * from './scenarios';
export * from './sse';
export * from './azure-upload';
export * from './analytics';
export * from './event-source';
export * from './presentation';
export * from './redis-cache';
